module.exports = __webpack_public_path__ + "71426cb8987f3bbc4dcd829b14707f3a.svg";


//////////////////
// WEBPACK FOOTER
// ./images/search-icon.svg
// module id = 77
// module chunks = 0